import { render } from "./PaymentSlipForm.vue?vue&type=template&id=66f54416&scoped=true&ts=true"
import script from "./PaymentSlipForm.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipForm.vue?vue&type=script&lang=ts"

import "./PaymentSlipForm.vue?vue&type=style&index=0&id=66f54416&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f54416"]])

export default __exports__